export const IDLE_TIMER_TYPE = {
    MAIN: "MAIN",
    SUCCESS_SCREEN: "SUCCESS_SCREEN"
}